import { defineMessages } from "@/i18n";
import en from "./en";

export const libMemoryMessages = defineMessages("lib-memory", en);
